import Clock from './Clock'

export * from './Clock'

export default Clock
